import { render, staticRenderFns } from "./EvidenceCategoryItem.vue?vue&type=template&id=1458be7d"
import script from "./EvidenceCategoryItem.vue?vue&type=script&lang=ts"
export * from "./EvidenceCategoryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports